<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="error">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="error--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text pl-2">{{ item.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <div v-if="item.contents.video" justify-center>
          <embed width="640" height="360" :src="'https://www.youtube.com/embed/' + item.contents.video"/>
        </div>
        <v-card-text>
          {{ item.comment }}
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: [ 'item' ],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    onClose () {
      this.$emit('closed')
    }
  }
}
</script>

<style>
</style>
